import React from "react";

import { Row, Col, Checkbox } from "antd";
import TextArea from "antd/es/input/TextArea";

const RecommendProductComponent = ({
  productInfo,
  currIdx,
  deleteRecommendProduct,
  recommendProductReason,
  selectedRow,
  selectedNutrients,
  handleNutrientsSelect,
  colSpan = 8,
}) => {
  return (
    <div className="inquiry-recommend-product-wrap">
      <div className="inquiry-recommend-product-info-wrap">
        <Row
          justify="space-between"
          wrap={false}
          className="inquiry-recommend-product-title-wrap"
        >
          <Col flex="none">
            <div className="inquiry-recommend-product-title">
              추천상품 {(currIdx + 1).toString().padStart(2, "0")}
            </div>
          </Col>
          <Col flex="auto">
            <Row gutter={[0, 8]}>
              {selectedNutrients?.length > 0 && (
                <>
                  {selectedNutrients.map((nutrients, idx) => (
                    <Col span={colSpan}>
                      <Checkbox
                        key={`${currIdx + 1}_select_nutrient_${idx}`}
                        id={nutrients.id}
                        name="select_nutrient"
                        value={nutrients.id}
                        onChange={(e) => handleNutrientsSelect(e, currIdx)}
                        checked={
                          productInfo.hasOwnProperty("recommend_tag") &&
                          productInfo.recommend_tag.includes(nutrients.id)
                        }
                      >
                        {nutrients.name}
                      </Checkbox>
                    </Col>
                  ))}
                </>
              )}
            </Row>
          </Col>
          <Col flex="none">
            <img
              className="inquiry-recommend-product-cancel-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/recommend_product_cancel_icon.png`}
              onClick={() => deleteRecommendProduct(productInfo.product_id)}
            />
          </Col>
        </Row>
        <Row className="inquiry-recommend-product-info">
          <Col className="inquiry-recommend-product-label" span={3}>
            브랜드명
          </Col>
          <Col className="inquiry-recommend-product-text" span={5}>
            {productInfo.product_brand_name}
          </Col>
          <Col className="inquiry-recommend-product-label" span={3}>
            상품명
          </Col>
          <Col className="inquiry-recommend-product-text" span={13}>
            {productInfo.product_name}
          </Col>
        </Row>
      </div>
      <TextArea
        allowClear
        placeholder="추천이유를 작성해주세요."
        value={selectedRow[currIdx].content}
        onChange={(e) => recommendProductReason(currIdx, e.target.value)}
      />
    </div>
  );
};

export default RecommendProductComponent;
